define('core/mediaConfig',[
    'underscore',
    'backbone',
], function (
    _,
    Backbone
) {
    'use strict';

    var MEDIA_PERSISTED_WIDTHS = [320, 480, 600, 800];

    // Calculates closest thumbnail width based on available
    // width (document.body.offsetWidth) and caches this value
    // for future use by PostView.
    function findClosestThumbnailSize() {
        var width = window.document.body.offsetWidth;

        // get closest image width we have to @width argument
        var thumbnailsWidths = MEDIA_PERSISTED_WIDTHS;
        var len = thumbnailsWidths.length;

        return _.find(thumbnailsWidths, function (__, i) {
            return (i + 1 === len) ||
                (Math.abs(thumbnailsWidths[i + 1] - width) > Math.abs(thumbnailsWidths[i] - width));
        });
    }

    var config = new Backbone.Model({
        collapsed: false,

        defaultIframeHeight: 300,
        mediaPersistedWidths: MEDIA_PERSISTED_WIDTHS,

        loadedThumbnailWidth: findClosestThumbnailSize(),
    });

    // for testing
    config.findClosestThumbnailSize = findClosestThumbnailSize;

    return config;
});

